import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const deleteIssueSlice = createSlice({
  name: "deleteIssueData",
  initialState: [],
  reducers: {
    setDeleteIssueData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setDeleteIssueData } = deleteIssueSlice.actions;

export const deleteIssueData = deleteIssueSlice.reducer;
